module.exports = __webpack_public_path__ + "img/mardian-pro.png";